import { api } from '@triumph/shared';

const getBasket = () => api.get('/api/partsfinder/basket');

export default getBasket;
